import { render, staticRenderFns } from "./ForgotPage.vue?vue&type=template&id=21f3a448"
import script from "./ForgotPage.vue?vue&type=script&lang=js"
export * from "./ForgotPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports